import type { IndicacaoStaffRow } from '@/pages/indicacoes/indicacoesFilters'

export type IndicacaoAba = 'abertas' | 'descartados' | 'nao_fecharam'

const FECHADOS = new Set(['ganho', 'pago', 'comissao_pendente', 'comissao_liberada'])

export function abaDaIndicacao(row: IndicacaoStaffRow): IndicacaoAba {
  if (row.leadInstance?.status === 'DESCARTADO') return 'descartados'
  if (row.publicStatus === 'perdido' || row.deal?.etapa === 'PERDIDO') return 'nao_fecharam'
  return 'abertas'
}

export function podeDescartar(row: IndicacaoStaffRow) {
  return abaDaIndicacao(row) === 'abertas' && !FECHADOS.has(row.publicStatus) && !row.deal?.etapa
}
